var SIN18 = 0.309017;
var COS18 = 0.951057;
var SIN36 = 0.587786;
var COS36 = 0.809017;
var result = [0.8, 0.8, 1, 1, 0.8];
var urlHeader = 'http://birth.internal.extantfuture.com/access';
var local = window.localStorage;
var retryTimes = 0;

var wechat_title;
var wechat_desc;
var wechat_share_url;

$(document).ready(function() {
  if (IsPC()) {
    $('.loading-img').css('margin-top', "200px");
    $('.loading-img').css('width', "40px");
    $('.loading-img').removeClass('bounce');
    $('#loading-status').text("请在手机上查看");
    $('.land').hide();
    return;
  }
  initWechatShare();
  queryDetailInfo();
  initMusicControl();
  var audio = $('#bgm-audio').get(0);
  audio.play();

  function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
      "SymbianOS", "Windows Phone",
      "iPad", "iPod"
    ];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
  }

  function initMusicControl() {
    document.addEventListener("WeixinJSBridgeReady", function() {
      audio.play();
    }, false);
    $('.music-control-container').click(function(event) {
      event.stopPropagation();
      if (audio.paused) {
        audio.play();
        $('.music-on').show();
        $('.music-off').hide();
      } else {
        audio.pause();
        $('.music-on').hide();
        $('.music-off').show();
      }
    })
  }

  function initWebReqHeader() {
    var seq;
    if (local.getItem('modoo_birth_seq') != null) {
      seq = parseInt(local.getItem('modoo_birth_seq') | 0)
    } else {
      seq = 0;
    }
    seq += 1;
    localStorage.setItem('modoo_birth_seq', seq);
    var WebReqHeader = {
      uuid: getUuid(),
      ua: navigator.userAgent,
      seq: seq,
    }
    return WebReqHeader;
  }

  function getUuid() {
    if (local.getItem('modoo_birth_uuid') != null) {
      return local.getItem('modoo_birth_uuid');
    } else {
      var timeNow = new Date();
      local.setItem('modoo_birth_uuid', timeNow.getTime().toString());
      return timeNow.getTime().toString();
    }
  }

  function queryDetailInfo() {
    if (getURLParameter('b') == null) {
      $('.loading-img').removeClass('bounce');
      $('#loading-status').text("贺卡链接错误");
      return;
    }
    var webReqHeader = initWebReqHeader();
    var requestData = {
      cmd: 2040,
      WebReqHeader: webReqHeader,
      request: {
        babyId: getURLParameter('b')
      }
    }
    $.ajax({
      url: '/access',
      type: 'post',
      dataType: 'json',
      data: JSON.stringify(requestData),
      success: function(data) {
        if (data.ret == 0) {
          var responseData = $.parseJSON(data.response);
          if (responseData.ret != undefined && responseData.ret.code == 100) {
            loadBabyInfo(responseData.detail);
            $('.loading').hide();
            $('.swiper-container').show();
            var mySwiper = new Swiper('.swiper-container', {
              direction: 'vertical',
              mousewheelControl: true,
              onInit: function(swiper) {
                swiperAnimateCache(swiper);
                swiperAnimate(swiper);
              },
              onSlideChangeEnd: function(swiper) {
                swiperAnimate(swiper);
              }
            })
          } else {
            retry();
          }
        } else {
          retry();
        }
      }
    });
  }

  function retry() {
    if (retryTimes > 1) {
      $('.loading-img').removeClass('bounce');
      $('#loading-status').text("网络出错啦，请刷新下再试试吧");
      return;
    }
    retryTimes++;
    window.setTimeout(function() {
      queryDetailInfo();
    }, 2000);
  }

  function loadBabyInfo(info) {
    $('.baby-photo-container').css("background-image", ("url(" + getBabyImgURL(info.babyImgUrl) + ")"));
    $('#mother-name').text(info.userName);
    $('#baby-name, #ad-baby-name').text(info.babyName);
    $('#baby-gender-show').text(info.babyGender == 1 ? "小王子" : "小公主");
    $('#baby-gender').text(info.babyGender == 1 ? "男" : "女");
    $('#baby-gender').text(info.babyGender == 1 ? "男" : "女");
    $('#baby-birthday').text(showDateFormat(info.babyBornTs));
    $('#baby-weight').text(showWeightFormat(info.babyWeight));
    $('#baby-height').text(info.babyHeight);
    $('#baby-sign').text(showSignName(info.babyBornTs));
    $('.baby-sign-img').attr('src', getSignPngPath(info.babyBornTs));
    $('#first-test-date').text(showDateFormat(info.firstHBTestTs));
    $('#last-test-date').text(showDateFormat(info.lastHBTestTs));
    $('#test-totle-num').text(info.totalHBTestCount);
    $('#test-earliest-time').text(info.earliestTestTime);
    $('#test-latest-time').text(info.latestTestTime);
    $('#test-period').text(info.totalUseDays);
    $('#average-bpm').text(info.averageBPM);
    $('#modoo-baby-totle').text(info.totalBabyNum);
    if (info.userHeadImgUrl != null && info.userHeadImgUrl != undefined && info.userHeadImgUrl.length > 0) {
      $('.back-img-user-avatar img').attr('src', info.userHeadImgUrl);
    }
    result[0] = calcPos(info.fetalPositionStar);
    result[1] = calcPos(info.heightStar);
    result[2] = calcPos(info.hbStar);
    result[3] = calcPos(info.averageBPMStar);
    result[4] = calcPos(info.weightStar);
    var totleStart = info.fetalPositionStar + info.heightStar + info.hbStar + info.averageBPMStar + info.weightStar;
    $('#baby-modoo-sign').html(calcModooBabySign(totleStart, info.babyGender, info.babyName));
    drawBrithChart(result);
    wechat_title = "喜得" + (info.babyGender == 1 ? "公子" : "千金") + " " + showWeightFormat(info.babyWeight);
    wechat_desc = "母" + (info.babyGender == 1 ? "子" : "女") + "平安，欢迎来围观，我带着宝贝，你带着笑～";
    wechat_share_url = getBabyImgIconURL(info.babyImgUrl);
  }

  function getBabyImgURL(mixUrl) {
    return mixUrl.split(',')[0];
  }

  function getBabyImgIconURL(mixUrl) {
    return mixUrl.split(',')[1];
  }

  function calcModooBabySign(star, gender, name) {
    var babyTitle = gender == 1 ? "安静美男子" : "恬静小淑女";
    if (star > 5) {
      babyTitle = gender == 1 ? "标兵小正太" : "优雅小公举";
    }
    if (star > 10) {
      babyTitle = gender == 1 ? "怪力小霸王" : "百变小魔女";
    }
    var babyModooSignresult = "经萌动非官方组委会认证<br>" + name + '在萌动孕程中<br>获得 "' + babyTitle + '" 称号';
    return babyModooSignresult;
  }

  function calcPos(start) {
    return 1 - (3 - start) * 0.2;
  }

  function drawBrithChart(result) {

    var chart_canvas = document.getElementById("birth-chart");
    var WINTH = 130;
    if (window.innerWidth > 320) {
      WINTH = 150;
    }
    if (window.innerWidth > 380) {
      WINTH = 165;
    }
    var R = WINTH / 2;
    chart_canvas.width = WINTH;
    chart_canvas.height = WINTH;

    var ctx = chart_canvas.getContext("2d");
    ctx.lineWidth = 1;
    ctx.strokeStyle = "#FFF";
    ctx.fillStyle = "rgba(255,255,255,0.24)";

    ctx.beginPath();
    ctx.moveTo(R, 0);
    ctx.lineTo((1 - COS18) * R, (1 - SIN18) * R);
    ctx.lineTo((1 - SIN36) * R, (1 + COS36) * R);
    ctx.lineTo((1 + SIN36) * R, (1 + COS36) * R);
    ctx.lineTo((1 + COS18) * R, (1 - SIN18) * R);
    ctx.lineTo(R, 0);
    ctx.stroke();
    ctx.closePath();

    ctx.beginPath();
    ctx.moveTo(R, R);
    ctx.lineTo(R, 0);
    ctx.moveTo(R, R);
    ctx.lineTo((1 - COS18) * R, (1 - SIN18) * R);
    ctx.moveTo(R, R);
    ctx.lineTo((1 - SIN36) * R, (1 + COS36) * R);
    ctx.moveTo(R, R);
    ctx.lineTo((1 + SIN36) * R, (1 + COS36) * R);
    ctx.moveTo(R, R);
    ctx.lineTo((1 + COS18) * R, (1 - SIN18) * R);
    ctx.stroke();
    ctx.closePath();

    ctx.beginPath();
    ctx.moveTo(R, (1 - result[0]) * R);
    ctx.lineTo((1 - COS18 * result[1]) * R, (1 - SIN18 * result[1]) * R);
    ctx.lineTo((1 - SIN36 * result[2]) * R, (1 + COS36 * result[2]) * R);
    ctx.lineTo((1 + SIN36 * result[3]) * R, (1 + COS36 * result[3]) * R);
    ctx.lineTo((1 + COS18 * result[4]) * R, (1 - SIN18 * result[4]) * R);
    ctx.lineTo(R, (1 - result[0]) * R);
    ctx.fill();
    ctx.closePath();
  }

  function showDateFormat(ts) {
    var bornTs = ts * 1000;
    var bornTime = new Date(bornTs);
    return bornTime.getFullYear() + '/' + (bornTime.getMonth() + 1) + '/' + bornTime.getDate();
  }

  function showSignName(ts) {
    var bornTs = ts * 1000;
    var bornTime = new Date(bornTs);
    return getAstroName(bornTime.getMonth() + 1, bornTime.getDate());
  }

  function getSignPngPath(ts) {
    var bornTs = ts * 1000;
    var bornTime = new Date(bornTs);
    return 'img/sign' + getAstroNum(bornTime.getMonth() + 1, bornTime.getDate()) + '.png';
  }

  function showWeightFormat(weight) {
    var result = parseInt(weight / 10) + '斤';
    if (weight % 10 > 0) {
      result += weight % 10 + '两';
    }
    return result;
  }

  function initWechatShare() {
    $.ajax({
      type: 'POST',
      url: 'https://zc.meng-dong.com/wx/jdzc',
      data: {
        code: '0',
        url: window.location.href.split('#')[0]
      },
      async: true,
      success: function(res) {
        var data = $.parseJSON(res) || {};
        initWechatJs(data);
      },
      error: function() {
        console.log('网络错误');
      }
    });
  }

  function initWechatJs(data) {
    wx.config({
      debug: false,
      appId: data.appId,
      timestamp: data.timestamp,
      nonceStr: data.nonceStr,
      signature: data.signature,
      jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
    });

    wx.ready(function() {
      wx.onMenuShareTimeline({
        title: wechat_title,
        desc: wechat_desc,
        link: window.location.href, // 分享链接
        imgUrl: wechat_share_url,
        success: function(data) {
          // 用户确认分享后执行的回调函数
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      });

      wx.onMenuShareAppMessage({
        title: wechat_title,
        desc: wechat_desc,
        link: window.location.href,
        imgUrl: wechat_share_url,
        success: function(data) {
          // 用户确认分享后执行的回调函数
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      });

      wx.onMenuShareQQ({
        title: wechat_title,
        desc: wechat_desc,
        link: window.location.href,
        imgUrl: wechat_share_url,
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      });

      wx.onMenuShareWeibo({
        title: wechat_title,
        desc: wechat_desc,
        link: window.location.href,
        imgUrl: wechat_share_url,
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      });

      wx.onMenuShareQZone({
        title: wechat_title,
        desc: wechat_desc,
        link: window.location.href,
        imgUrl: wechat_share_url,
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      });
    });
  }

});

function getAstroName(month, day) {
  var s = "魔羯水瓶双鱼白羊金牛双子巨蟹狮子处女天秤天蝎射手魔羯";
  var arr = [20, 19, 21, 20, 21, 22, 23, 23, 23, 24, 23, 22];
  return s.substr(month * 2 - (day < arr[month - 1] ? 2 : 0), 2);
}

function getAstroNum(month, day) {
  var s = "00010203040506070809101100";
  var arr = [20, 19, 21, 20, 21, 22, 23, 23, 23, 24, 23, 22];
  return s.substr(month * 2 - (day < arr[month - 1] ? 2 : 0), 2);
}

function getURLParameter(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null
}
